import { render, staticRenderFns } from "./SidebarTeacher.vue?vue&type=template&id=4b03aaad&scoped=true"
import script from "./SidebarTeacher.vue?vue&type=script&lang=js"
export * from "./SidebarTeacher.vue?vue&type=script&lang=js"
import style0 from "./SidebarTeacher.vue?vue&type=style&index=0&id=4b03aaad&prod&lang=css"
import style1 from "./SidebarTeacher.vue?vue&type=style&index=1&id=4b03aaad&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03aaad",
  null
  
)

export default component.exports